import React from 'react';
import { Box } from '@popmenu/common-ui';
import { Skeleton } from '@material-ui/lab';
import { classNames } from '../../../utils/withStyles';

type DishCardsSkeletonProps = {
  cardContainerClassName: string
  cardSkeletonClassName: string
  className?: string | null | undefined
  length: number
}

export const DishCardsSkeleton = ({ cardContainerClassName, cardSkeletonClassName, className = null, length }: DishCardsSkeletonProps) => (
  <React.Fragment>
    {Array.from({ length }).map((_, index) => (
      <Box
        key={index}
        className={classNames(
          'skeleton',
          className,
          cardContainerClassName,
        )}
        component="div"
      >
        <Skeleton
          className={cardSkeletonClassName}
          variant="rect"
        />
      </Box>
    ))}
  </React.Fragment>
);
